import { normalizeSearchText } from './hotspeed-manual-utils.js';

function initManualCenter(root) {
  if (root.dataset.manualCenterReady === 'true') return;
  root.dataset.manualCenterReady = 'true';

  const cards = [...root.querySelectorAll('.hs-manual-card')];
  const grid = root.querySelector('[data-manual-grid]');
  const search = root.querySelector('[data-manual-search]');
  const type = root.querySelector('[data-manual-type]');
  const count = root.querySelector('[data-manual-count]');
  const empty = root.querySelector('[data-manual-empty]');

  cards.sort((a, b) =>
    a.dataset.title.localeCompare(b.dataset.title, undefined, { numeric: true }),
  );
  cards.forEach((card) => grid.append(card));

  [...new Set(cards.map((card) => card.dataset.type).filter(Boolean))]
    .sort((a, b) => a.localeCompare(b))
    .forEach((value) => type.add(new Option(value, value)));

  const apply = () => {
    const query = normalizeSearchText(search.value);
    const selectedType = type.value;
    let visible = 0;

    cards.forEach((card) => {
      const haystack = normalizeSearchText(`${card.dataset.title} ${card.dataset.model}`);
      const show =
        (!query || haystack.includes(query)) &&
        (!selectedType || card.dataset.type === selectedType);
      card.hidden = !show;
      if (show) visible += 1;
    });

    const template = visible === 1 ? root.dataset.countOne : root.dataset.countMany;
    count.textContent = template.replace('[count]', String(visible));
    empty.hidden = visible !== 0;
  };

  search.addEventListener('input', apply);
  type.addEventListener('change', apply);
  apply();
}

export function manualCenterRoots(scope) {
  const roots = [...scope.querySelectorAll('[data-manual-center]')];
  if (scope.matches?.('[data-manual-center]')) roots.unshift(scope);
  return roots;
}

function initManualCenters(scope) {
  manualCenterRoots(scope).forEach(initManualCenter);
}

if (typeof document !== 'undefined') {
  initManualCenters(document);
  document.addEventListener('shopify:section:load', (event) => initManualCenters(event.target));
}
